import styled from 'styled-components'

interface IVendorDetailStyledProps {}

export const VendorDetailStyled = styled.div<IVendorDetailStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
